import "./utils/instrument.ts";


import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./styles/index.css";

import { Provider } from 'react-redux';
import { store } from './store/store';
import i18n from "./i18n.ts";
import { loadToken } from "./store/token.slice.ts";

i18n.on('languageChanged', (lang) => {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
});

document.documentElement.lang = i18n.language;
document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
const rootElement = document.getElementById('root');


store.dispatch(loadToken());

if (rootElement) {
  createRoot(rootElement).render(
      <Provider store={store}>
        <App />
      </Provider>
  );
} else {
  console.error('Failed to find the root element');
}